<template>
  <div>
    <van-loading
      v-if="loading"
      color="white"
      class="p-2 m-4 rounded mx-auto loading" />
    <template v-else>
      <article
        v-if="show"
        :style="articleSytle">
        <h3 class="mx-3 my-2">{{ !doctor ? '影像检查记录' : '选择检查记录' }}</h3>
        <template v-if="list.length > 0">
          <FilmListItem
            v-for="item of list"
            :data="item"
            :type="type"
            :doctor="doctor"
            :key="item.patient_info.image_id"
            @checked="onChecked"
            @cancel="onCancel"/>
        </template>
        <div
          v-else
          class="p-5 text-center text-muted">
          {{ !doctor ? '暂无数据' : '暂无当前医生对应类型的检查记录，请重新选择医生问诊' }}
        </div>
      </article>
    </template>
  </div>
</template>

<script>
import format from 'date-fns/format';
import addYears from 'date-fns/addYears';
import subYears from 'date-fns/subYears';
import bus from '@/libs/bus';
import FilmListItem from './FilmListItem.vue';

export default {
  name: 'FilmList',
  components: {
    FilmListItem,
  },
  props: {
    type: {
      type: String,
      default: 'film',
    },
    card: {
      type: Object,
      default() {
        return {
          hospital_id: '',
          medical_card_id: '',
        };
      },
    },
    hasCard: {
      type: Boolean,
      default: false,
    },
    doctor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      show: false,
      tempHospitalId: '',
      tempMedicalCardId: '',
      loading: false,
    };
  },
  computed: {
    hospitalId: {
      get() {
        return this.card.hospital_id;
      },
      set(value) {
        this.card.hospital_id = value;
      },
    },
    medicalCardId: {
      get() {
        return this.card.medical_card_id;
      },
      set(value) {
        this.card.medical_card_id = value;
      },
    },
    articleSytle() {
      return 'paddingBottom: 50px';
    },
  },
  watch: {
    hasCard() {
      this.handleLoad();
    },
  },
  mounted() {
    this.changeCard();
    if (this.hasCard) {
      this.handleLoad();
    }
  },
  activated() {
    this.changeCard();
    if (this.hasCard) {
      this.handleLoad();
    }
  },
  methods: {
    async handleLoad() {
      this.loading = true;
      if (this.hasCard) {
        const { hospitalId } = this;
        const patientId = this.medicalCardId;
        const startDay = format(subYears(new Date(), 5), 'YYYY-MM-dd');
        const endDay = format(addYears(new Date(), 1), 'YYYY-MM-dd');
        let response;
        if (!this.doctor) {
          response = await this.$http.get('/cloud-film-api/webapi/common/get-reports', {
            hospital_id: hospitalId,
            type: 'm',
            patient_id: patientId,
            start_day: startDay,
            end_day: endDay,
          }).catch(() => {
            this.loading = false;
          });
        } else {
          response = await this.$http.get('/cloud-film-api/webapi/common/get-reports', {
            hospital_id: hospitalId,
            type: 'm',
            patient_id: patientId,
            start_day: startDay,
            end_day: endDay,
            doctor_category: sessionStorage.getItem('report-type'),
            purchased: true,
          }).catch(() => {
            this.loading = false;
          });
        }
        this.show = true;
        if (response && response.length > 0) {
          this.list = response;
          bus.$emit('load-list', true);
        } else {
          this.list = [];
          bus.$emit('load-list', false);
        }
      } else {
        this.show = false;
      }
      this.loading = false;
    },
    async changeCard() {
      bus.$on('change', async (card) => {
        // this.card = await card;
        this.hospitalId = await card.hospital_id;
        this.medicalCardId = await card.medical_card_id;
        this.handleLoad();
      });
    },
    onChecked(value) {
      this.$emit('checked', value);
    },
    onCancel(value) {
      this.$emit('cancel', value);
    },
  },
};
</script>

<style>
.loading {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
